export const isOnline = "@/online/@isOnline";
export const isOnlineSuccess = "@/online/@isOnlineSuccess";
export const isOnlineFailure = "@/online/@isOnlineFailure";
